<template>
  <div class="text_left">
    <title-bar-back
      v-if="this.$route.query.whereFrom !== 'app'"
      :title="'周期购配送规则'"
      @back="back"
    >
      <div class="title_right"></div>
    </title-bar-back>
    <div class="exp_top text_center">(以下均为北京时间)</div>
    <div class="exp_bottom">
      <div class="font0">
        <span class="title_title">一、定义</span>
      </div>
      <div class="exp_item">
        （一）周期购商品，是指为满足买家周期配送需求而提供的周期配送的商品，其无线端商品详情页带有周期购流程信息
      </div>
      <div class="exp_item">
        （二）周期购订单，是指买家购买特定商品规格达成购买周期商品的特殊订单，订单内容包括配送周期、配送频次、配送地址、配送时间、每期件数、总件数及订单总价。
      </div>
      <div class="exp_item">
        （三）因周期购商品时效性较强，购买周期购订单，对应配送周期将默认较优的配送生产日期和对应频率，具体时间以页面展示为准。
      </div>
    </div>
    <div class="exp_bottom">
      <div class="font0">
        <span class="title_title">物流说明</span>
      </div>
      <div class="exp_item">
        1、鲜奶由国内顺丰冷链配送，发货仓为：北京、杭州、重庆、广州，根据收货地址就近发货，发货后请保持电话畅通，预计<span
          class="font_color1"
          >1-2天送达</span
        >至您手中；
      </div>
      <div class="exp_item">
        2、每批次每周最早可发货时间：<span class="font_color1"
          >杭州仓每周五</span
        >开始发货，<span class="font_color1">北京仓、广州仓、重庆仓每周日</span
        >开始发货；
      </div>
      <div class="exp_item">
        3、单件装（2瓶）：在货量充足的情况下，每日<span class="font_color1"
          >13点前</span
        >下单<span class="font_color1">当天</span>可发货，<span
          class="font_color1"
          >13点后</span
        >下单<span class="font_color1">次日</span>发货，<span
          class="font_color1"
          >北京仓、广州仓、重庆仓等覆盖地址周六不发货</span
        >；
      </div>
      <div class="exp_item">
        4、多周期（超1周）：默认每周发最新生产日期的鲜奶，各仓<span
          class="font_color1"
          >周六13点前</span
        >下单<span class="font_color1">当周</span>可发货，<span
          class="font_color1"
          >13点后</span
        >下单，顺延<span class="font_color1">下周</span>最早发货时间发货；
      </div>
      <div class="exp_item">
        5、如遇特殊情况（春节、澳洲圣诞节、双十一、双十二）等，会根据实际情况暂停或调整派送。
      </div>
    </div>
    <div class="exp_bottom">
      <div class="font0">
        <span class="title_title">周期购流程</span>
      </div>
      <div class="exp_item11">
        温馨提示：如需暂停或取消配送计划，请提前修改，包裹开始处理后无法变更已处理的配送计划。
      </div>
      <img src="@/assets/order/exp_step.png" alt="" class="step_milk font0" />
    </div>
    <div class="exp_bottom">
      <div class="font0">
        <span class="title_title">二、选择发货时间</span>
      </div>
      <div class="exp_item">
        只能选择下单时间一个月以内的预计发货时间。
      </div>
    </div>
    <div class="exp_bottom">
      <div class="font0">
        <span class="title_title">三、等待配送</span>
      </div>
      <div class="exp_item">
        （一）修改地址&联系人：周期订单修改地址，仅针对等待配送的周期订单修改地址。“正在配送”
        &“已发出包裹” 不支持地址修改。
      </div>
      <!-- <div class="exp_item">
        （二）修改时间：买家如因特殊情况不便接收货品，可对应修改“等待配送”
        的周期订单。周期商品订单时间修改仅支持“往后”修改，可修改时间请以页面为准，每个订单仅支持3次时间修改（包含暂停订单）。
      </div>
      <div class="exp_item">
        （三）暂停订单：周期订单仅支持3次时间修改，如选择暂停订单，将默认暂停1个月，如恢复派送，将于最近可配送日期安排进行配送。
      </div> -->
      <!-- 2021-06-08 时雨修改 -->
      <div class="exp_item">
        （二）修改时间：如买家因特殊情况不便接收，可相应修改“等待运送品”的周期顺序。生命周期商品订单时间修改支持“往后”，可修改时间请以页面为准；周期订单支持月卡
        2 次，季卡4次修改，年卡6次时间修改；（暂停暂停订单）。
      </div>
      <div class="exp_item">
        （三）暂停订单：如选择暂停订单，将默认暂停 1
        个月，如恢复派送，即将于近期可暂停日期进行维护。
      </div>
    </div>
    <div class="exp_bottom bottom_mr">
      <div class="font0">
        <span class="title_title">四、周期售后</span>
      </div>
      <div class="exp_item item_mr">
        （一）当周期订单出于“未付款”&“待发货”状态，买家可选择“取消订单”，若买家选择“取消订单”，则该订单将被取消。
      </div>
      <div class="exp_item item_mr">
        （二）如周期订单首期“已发货”，选择剩余期数“取消订单”，若买家选择“取消订单”，则该订单将被取消。
      </div>
      <div class="exp_item item_mr">
        （三）如需对应售后包裹，其售后存在对应时效，请在时效内完成售后申请，具体以商品页面显示为准。
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  components: {
    TitleBarBack
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.exp_top {
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  line-height: 35px;
  padding: 0 12px;
  background: #fff;
}
.exp_bottom {
  padding: 10px 15px 5px;
  background: #fff;
}
.bottom_mr {
  padding-bottom: 24px;
}
.title_img {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.title_title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(221, 145, 50, 1);
  line-height: 22px;
  margin-left: 5px;
  vertical-align: middle;
}
.exp_item {
  margin-top: 5px;
  font-size: 14px;
  color: #888;
  line-height: 24px;
}
.item_mr {
  margin-top: 24px;
}
.exp_item11 {
  margin-top: 5px;
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
}
.step_milk {
  display: block;
  margin: 24px 0 24px 12px;
  width: 297px;
}
.font_color1 {
  font-weight: 500;
  color: #222;
}
.bot_bottom {
  padding-bottom: 30px;
}
</style>
